import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { EmbersMenuItem } from '../../menuItem/menuItem';
import { BasicSelectContainer, StyledBasicSelectLaunchButton } from './basicSelectStyles';
import { EmbersMenu } from '../../menu';
export function EmbersBasicSelect(props) {
  var className = props.className,
    _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    title = props.title,
    id = props.id,
    _props$customOptionVa = props.customOptionValue,
    customOptionValue = _props$customOptionVa === void 0 ? 'value' : _props$customOptionVa,
    _props$customOptionLa = props.customOptionLabel,
    customOptionLabel = _props$customOptionLa === void 0 ? 'label' : _props$customOptionLa,
    value = props.value,
    options = props.options,
    disabled = props.disabled,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    onChange = props.onChange,
    required = props.required;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuIsOpen = _useState4[0],
    setMenuIsOpen = _useState4[1];
  var menuAnchorRef = useRef(null);

  // Allow controlled open
  useEffect(function () {
    if (open === undefined) return;
    if (open) {
      setMenuIsOpen(true);
      if (id) {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 || _document$getElementB.click();
      }
    } else {
      handleCloseMenuRequest();
    }
  }, [open]);
  var handleOptionClick = function handleOptionClick(option) {
    setSelectedOption(option);
    onChange === null || onChange === void 0 || onChange(option);
    handleCloseMenuRequest();
  };
  var handleOpenMenuRequest = function handleOpenMenuRequest(buttonElem) {
    menuAnchorRef.current = buttonElem;
    setMenuIsOpen(true);
  };
  var handleCloseMenuRequest = function handleCloseMenuRequest() {
    var _menuAnchorRef$curren;
    (_menuAnchorRef$curren = menuAnchorRef.current) === null || _menuAnchorRef$curren === void 0 || _menuAnchorRef$curren.focus();
    menuAnchorRef.current = null;
    setMenuIsOpen(false);
  };
  var getMenuItems = function getMenuItems() {
    var selectedValue = selectedOption ? selectedOption[customOptionValue] : undefined;
    var itemsArray = options.map(function (option, index) {
      var optionValue = option[customOptionValue];
      var prefixIconSpan;
      if (option.prefixIcon) {
        prefixIconSpan = /*#__PURE__*/React.createElement("span", {
          className: option.prefixIcon
        });
      }
      return /*#__PURE__*/React.createElement(EmbersMenuItem, {
        key: optionValue + '_' + index,
        value: optionValue,
        selected: selectedValue === optionValue,
        prefixIcon: prefixIconSpan,
        "aria-posinset": index,
        "aria-setsize": options.length,
        onClick: function onClick() {
          handleOptionClick(option);
        }
      }, option[customOptionLabel]);
    });
    return itemsArray;
  };
  var renderButton = function renderButton() {
    var hasSelectedOption = selectedOption && selectedOption[customOptionValue];
    var legendElem = null;
    var labelText = required ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: "LaunchButton-text-requiredPostfix"
    }, "\xA0*")) : title;
    if (hasSelectedOption) {
      legendElem = required ? /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true",
        className: "LaunchButton-fieldset-requiredPostfix"
      }, "\xA0*")) : /*#__PURE__*/React.createElement("legend", null, title);
      labelText = selectedOption[customOptionLabel];
    }
    return /*#__PURE__*/React.createElement(StyledBasicSelectLaunchButton, {
      id: id,
      ariaProps: {
        'aria-controls': menuIsOpen ? "menu-".concat(id) : undefined,
        'aria-expanded': 'false',
        'aria-haspopup': 'listbox'
        // 'aria-labelledby': `${id}-label ${id}-value`
      },

      menuIsOpen: menuIsOpen,
      onOpenMenuRequest: handleOpenMenuRequest,
      onCloseMenuRequest: handleCloseMenuRequest,
      disabled: disabled,
      tabIndex: tabIndex
    }, /*#__PURE__*/React.createElement("span", {
      id: "".concat(id, "-value"),
      className: classnames({
        'LaunchButton-text': true,
        'LaunchButton-text-disabled': disabled,
        'LaunchButton-text-valueSelected': hasSelectedOption
      })
    }, labelText), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": true,
      className: classnames({
        'LaunchButton-arrowIcon': true,
        'LaunchButton-arrowIcon-disabled': disabled,
        'icon-expand-more': true,
        'is-open': menuIsOpen
      })
    }), /*#__PURE__*/React.createElement("fieldset", {
      id: "".concat(id, "-label"),
      className: classnames({
        'LaunchButton-fieldset-disabled': disabled,
        'LaunchButton-fieldset-emptyLegend': !hasSelectedOption,
        'LaunchButton-fieldset-menuIsOpen': menuIsOpen
      }),
      "aria-hidden": true
    }, legendElem));
  };
  return /*#__PURE__*/React.createElement(BasicSelectContainer, {
    className: className
  }, renderButton(), /*#__PURE__*/React.createElement(EmbersMenu, {
    id: 'menu-' + id,
    anchorEl: menuAnchorRef.current,
    open: menuIsOpen,
    onClose: handleCloseMenuRequest,
    fullWidth: true,
    verticalOffset: 0
  }, getMenuItems()));
}